import styles from './Functions.module.scss'
import Popup from 'components/common/PopupCTA/PopupCTA'

const Functions: React.FunctionComponent = () => {
  return (
    <>
      <section className={styles.topPart}>
        <h1>機能について</h1>
        <div className={styles.textWrapper}>
          <div className={styles.text}>
            <p>
              flamingoには、自由度の高い画面改修および 安心・安定のサイト運用を支える
              <br />
              様々な機能があります。ここでは大きく3つの機能を紹介します。
            </p>
            <a href="https://aitria.co.jp/contact" target="_blank" className={`${styles.button} ${styles.blackButton}`}>
              <span>お問い合わせ</span>
            </a>
          </div>
        </div>
      </section>
      <section className={styles.solutionMethod}>
        <div className={styles.blurRedCircle}></div>
        <div className={styles.topWrapper}>
          <h2>
            ソリューション別に特化した
            <br />
            最適化方式の提供
          </h2>
          <p>
            flamingoでは「テンプレート」と「フィルター」という2種類の方式を提供しています。
            <br />
            ソリューション別に特化することで、柔軟かつ効率のよい画面改修を可能にしています。
          </p>
        </div>
        <ul className={styles.methods}>
          <li className={styles.item}>
            <img src="/img/LP/flamingo/template.png" alt="" />
            <div>
              <p className={styles.miniTitle}>
                <span className={`${styles.redBorder} ${styles.titleSide}`}></span>01
              </p>
              <h3>テンプレートによるページ最適化</h3>
              <p>
                1つ目は「テンプレート」方式です。プロジェクト作成時に「テンプレート」を選択することで使用可能になり、実行条件および変換後ページを「テンプレート」で設定することで、ウェブページを全体変換します。
                <br />
                自由にHTMLを記述して別のページに変換することが可能なため、大規模ウェブシステムのモダナイゼーションなどに向いている方式です。
              </p>
            </div>
          </li>
          <li className={styles.item}>
            <img src="/img/LP/flamingo/filter.png" alt="" />
            <div>
              <p className={styles.miniTitle}>
                <span className={`${styles.redBorder} ${styles.titleSide}`}></span>02
              </p>
              <h3>フィルターによるページ最適化</h3>
              <p>
                2つ目は「フィルター」方式です。プロジェクト作成時に「フィルター」を選択することで使用可能になり、変換処理内容を「フィルター」で設定し、フィルターの実行条件を「トリガー」で設定することで、ウェブページを部分変換します。
              </p>
            </div>
          </li>
        </ul>
      </section>
      <section className={styles.functions}>
        <div>
          <h3>
            安全運用のため
            <br />
            プロジェクト権限管理
          </h3>
          <p>
            本番環境へのリリース・ステージング環境への配置は、権限の付与されたユーザーにのみ可能です。リリース権限は作業権限・管理権限と別で付与する事も可能なため、より安全な作業・柔軟なアカウント運用を実現します。またそれぞれの権限は、プロジェクト管理者が任意のユーザーへ自由に付与する事ができます。
          </p>
          <img src="/img/LP/flamingo/function1.png" alt="" />
        </div>
        <div>
          <h3>安心を支えるリリース管理</h3>
          <p>
            どのユーザーがいつリリースを行なったかの履歴は全て残ります。それぞれのリリース内容を確認し、各時点へのロールバックも可能なので、安心してサイト改善に取り組む事ができます。またリリース履歴以外にも、作業内容やログイン等の履歴も参照可能です。
          </p>
          <img src="/img/LP/flamingo/function2.png" alt="" />
        </div>
        <div>
          <h3>
            画面改修をサポートする
            <br />
            リアルタイムプレビュー
          </h3>
          <p>
            flamingoでは、サイト制作用のエディター画面をブラウザ経由で提供しています。エディターにはプレビュー機能を搭載しておりリアルタイムに確認することができます。また、プレビュー画面をデスクトップ・タブレット・モバイルモードに切り替えることができ、クロスデバイスの確認も容易にします。
          </p>
          <img src="/img/LP/flamingo/function3.png" alt="" />
        </div>
      </section>
      <div className={styles.contentTableBlock}>
        <h2 className={styles.miniTitle}>
          <span className={`${styles.redBorder} ${styles.titleSide}`}></span>フィルター変換機能
        </h2>
        <div className={styles.table}>
          <table>
            <tr>
              <th>主要機能</th>
              <th>説明</th>
            </tr>
            <tr>
              <td>トリガー管理</td>
              <td>
                トリガーの作成・変更・複製・削除を行うことができます。各トリガーは入力・条件を組み合わせて設定でき、フィルターから利用することができます。
              </td>
            </tr>
            <tr>
              <td>フィルター管理</td>
              <td>
                フィルターの作成・変更・複製・削除を行うことができます。各フィルターは入力・処理・出力をトリガーと組み合わせて設定でき、複雑な出力にはスニペットを利用することもできます。
              </td>
            </tr>
            <tr>
              <td>オリジナルコンテンツ選択</td>
              <td>
                オリジナルのウェブサイトから動的な活用を再利用したい場合に、フィルターとトリガーを選択して変換をする事ができます。
              </td>
            </tr>
            <tr>
              <td>リアルタイムプレビュー</td>
              <td>変更内容は即座に反映されてリアルタイムで各画面の変更内容をプレビューすることができます。</td>
            </tr>
            <tr>
              <td>ビューモードの切替</td>
              <td>
                プレビュー機能ではマルチスクリーンに対応するため、各デバイスのサイズごとにViewのサイズを変更できます。
              </td>
            </tr>
            <tr>
              <td>スニペット管理</td>
              <td>開発上必要なソースは、スニペットとして登録、削除、一覧を管理することができます。</td>
            </tr>
            <tr>
              <td>ファイル管理</td>
              <td>
                画像ファイル・CSSファイル・JSファイルとテンプレート開発に必要なファイルのアップロード・変更・削除を行うことができます。
              </td>
            </tr>
            <tr>
              <td>編集履歴一覧</td>
              <td>各フィルター・トリガーに変更を加えた場合の編集の履歴一覧を閲覧・参照することができます。</td>
            </tr>
            <tr>
              <td>コラボレーション</td>
              <td>
                オフショア開発、リモート開発をサポートするために、IDEでは画面を見ながらチャットができるコラボレーション機能を提供しています。
              </td>
            </tr>
          </table>
        </div>
        <h2 className={styles.miniTitle}>
          <span className={`${styles.redBorder} ${styles.titleSide}`}></span>テンプレート変換機能
        </h2>
        <div className={styles.table}>
          <table>
            <tr>
              <th>主要機能</th>
              <th>説明</th>
            </tr>
            <tr>
              <td>ソース編集機能</td>
              <td>
                ソースコードは自由に変更することが可能です。提供されるテンプレートエンジンでは、条件分岐、ループ、IF文等の制御構文を利用することができます。
              </td>
            </tr>
            <tr>
              <td>オリジナルコンテンツ選択</td>
              <td>
                オリジナルのウェブサイトから動的な活用を再利用したい場合にマッピングする箇所を選択して表示するテンプレートに埋め込むことができます。
              </td>
            </tr>
            <tr>
              <td>編集履歴一覧</td>
              <td>各テンプレートに変更を加えた場合の編集の履歴一覧を閲覧・参照することが可能です。</td>
            </tr>
            <tr>
              <td>リアルタイムプレビュー</td>
              <td>変更内容は即座に反映されてリアルタイムで各画面の変更内容をプレビューすることができます。</td>
            </tr>
            <tr>
              <td>テンプレート管理</td>
              <td>
                URL単位・画面ID単位・デバイスタイプなど任意の条件に合致した際に表示させるテンプレートの作成・変更・複製等を行うことができます。
              </td>
            </tr>
            <tr>
              <td>ファイル管理</td>
              <td>
                画像ファイル・CSSファイル・JSファイルなどテンプレート開発に必要なファイルのアップロード・変更・削除を行うことができます。
              </td>
            </tr>
            <tr>
              <td>スニペット管理</td>
              <td>開発上必要なソースは、スニペットとして登録・削除・一覧を管理することができます。</td>
            </tr>
            <tr>
              <td>ビューモードの切替</td>
              <td>
                プレビュー機能ではマルチスクリーンに対応するため、各デバイスのサイズごとにViewのサイズを変更できます。
              </td>
            </tr>
            <tr>
              <td>モバイルプレビュー</td>
              <td>
                二次元バーコードを実機で読み込むことによって表示されるモバイルプレビューは、IDE上での変更もリアルタイムで変更内容が反映され、IDE内のプレビューと同期して稼働します。
              </td>
            </tr>
            <tr>
              <td>コラボレーション</td>
              <td>
                オフショア開発、リモート開発をサポートするために、IDEでは画面を見ながらチャットができるコラボレーション機能を提供しています。
              </td>
            </tr>
          </table>
        </div>
        <h2 className={styles.miniTitle}>
          <span className={`${styles.redBorder} ${styles.titleSide}`}></span>管理画面機能 (flamingo CP)
        </h2>
        <div className={styles.table}>
          <table>
            <tr>
              <th>主要機能</th>
              <th>説明</th>
            </tr>
            <tr>
              <td>プロジェクト管理</td>
              <td>
                利用ユーザーは、対象となるウェブサイトのURLを入力することによってプロジェクトの作成・編集・削除を行うことができます。
              </td>
            </tr>
            <tr>
              <td>ユーザー管理</td>
              <td>プロジェクト単位に関与するユーザーの招待・削除・変更とアサイン管理を行うことができます。</td>
            </tr>
            <tr>
              <td>権限管理</td>
              <td>
                プロジェクトにアサインされたユーザーは、テンプレートの編集・リリースの権限等の権限管理を行うことができます。
              </td>
            </tr>
            <tr>
              <td>ブランチ管理</td>
              <td>
                ソースコードの履歴管理ならびに並行開発を行う場合のブランチ作成・マージ・コンフリクトの解消などを行うことができます。
              </td>
            </tr>
            <tr>
              <td>リリース管理</td>
              <td>
                開発されたソースを本番のCDNならびにステージングに配置する場合には、リリースの予約・履歴・取り消しを行うことができます。
              </td>
            </tr>
            <tr>
              <td>プロファイル管理</td>
              <td>契約アカウントのプロフィールの編集、プランの変更を行うことができます。</td>
            </tr>
            <tr>
              <td>本番/ステージング</td>
              <td>本番リリース前の稼働確認を行うためのステージング環境が用意されています。(※プラン限定)</td>
            </tr>
            <tr>
              <td>Chromeエクステンション</td>
              <td>
                IDEへのアクセスは、別途Chrome Web
                Storeから提供されるエクステンションを追加することで対象サイトからエクステンションを経由して直接アクセスすることが可能です。
              </td>
            </tr>
            <tr>
              <td>ログイン機能</td>
              <td>管理画面のアクセスはログイン機能によってセキュリティを保護しています。</td>
            </tr>
            <tr>
              <td>スイッチャ―生成</td>
              <td>flamingoを稼働させるためのJSタグは管理画面から生成することができます。</td>
            </tr>
          </table>
        </div>
        <h2 className={styles.miniTitle}>
          <span className={`${styles.redBorder} ${styles.titleSide}`}></span>コンテンツ変換機能
        </h2>
        <div className={`${styles.table} ${styles.mb0}`}>
          <table>
            <tr>
              <th>主要機能</th>
              <th>説明</th>
            </tr>
            <tr>
              <td>変換処理方式</td>
              <td>
                利用ユーザーは、対象となるウェブサイトのURLを入力することによってプロジェクトの作成・編集・削除を行うことができます。
              </td>
            </tr>
            <tr>
              <td>コンテンツ解析&amp;抽出方式</td>
              <td>CSSセレクターならびにXpathによるオリジナルコンテンツの解析や取得が可能です。</td>
            </tr>
            <tr>
              <td>パラメーター</td>
              <td>抽出データの構造化、JSONフォーマットによるパラメーター管理が可能です。</td>
            </tr>
            <tr>
              <td>デバイス別変換</td>
              <td>User Agentを取得してデバイス別・OS別に出力される表示内容を変更することができます。</td>
            </tr>
            <tr>
              <td>フラミンゴAPI</td>
              <td>
                API機能によって、デバイス情報の取得・変換元URL情報の取得・特定のJavaScriptオブジェクトにプロパティを追加することができます。
              </td>
            </tr>
            <tr>
              <td>SSL対応</td>
              <td>SSL環境のページに対応可能です。</td>
            </tr>
            <tr>
              <td>Ajax対応</td>
              <td>Ajaxで稼働するページに対応可能です。</td>
            </tr>
          </table>
        </div>
      </div>
      <article>
        <Popup />
      </article>
    </>
  )
}

export default Functions
